import { useState, useEffect } from "react";
import {
  Navbar,
  MobileNav,
  Typography,
  IconButton,
  Button,
} from "@material-tailwind/react";
import Logo from "../../assets/images/commalax/Logo_white.png";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";

export default function Header() {
  const [openNav, setOpenNav] = useState(false);

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  // const navList = (
  //   <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-black">
  //     <Dropdown category={"CARE:NEL"} dropdownData={carenelCategories} />
  //     <Dropdown category={"innisfree"} dropdownData={innisfreeCategories} />
  //     <Dropdown category={"JM solution"} dropdownData={JMsolutionCategories} />
  //   </ul>
  // );
  const navList = (
    <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <Link
          to={paths.home}
          className="flex uppercase font-semibold items-center hover:border-b-2 transition duration-300"
        >
          Home
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <Link
          to={paths.contact}
          className="flex uppercase font-semibold items-center hover:border-b-2 transition duration-300"
        >
          Contact
        </Link>
      </Typography>
      <Typography
        as="li"
        variant="small"
        color="blue-gray"
        className="p-1 font-normal"
      >
        <a
          href={"https://commalax.com/"}
          className="flex uppercase font-semibold items-center hover:border-b-2 transition duration-300"
        >
          Shop
        </a>
      </Typography>
    </ul>
  );

  return (
    // <Navbar className="mx-auto max-w-screen-xl py-2 px-4 lg:px-8 lg:py-4 bg-transparent border-none">
    //   <div className="container mx-auto flex items-center justify-between text-blue-gray-900">
    //     <Link to={paths.home}>
    //       <h1 className="tracking-widest text-xl italic cursor-pointer font-bold">
    //         Commalax
    //       </h1>
    //     </Link>
    //     <div className="hidden lg:block">{navList}</div>
    //     <Link to={paths.contact}>
    //       <button className="hidden lg:inline-block hover:scale-105 transition bg-white text-[#F4C0C0] border-0 rounded-full shadow-lg btn-sm">
    //         <span>Contact Us</span>
    //       </button>
    //     </Link>
    //     <IconButton
    //       variant="text"
    //       className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
    //       ripple={false}
    //       onClick={() => setOpenNav(!openNav)}
    //     >
    //       {openNav ? (
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           fill="none"
    //           className="h-6 w-6"
    //           viewBox="0 0 24 24"
    //           stroke="currentColor"
    //           strokeWidth={2}
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M6 18L18 6M6 6l12 12"
    //           />
    //         </svg>
    //       ) : (
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           className="h-6 w-6"
    //           fill="none"
    //           stroke="currentColor"
    //           strokeWidth={2}
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M4 6h16M4 12h16M4 18h16"
    //           />
    //         </svg>
    //       )}
    //     </IconButton>
    //   </div>
    //   <MobileNav open={openNav}>
    //     <div className="container mx-auto">
    //       {navList}
    //       <Link to={paths.contact}>
    //         <button className="bg-white text-[#F4C0C0] border-0 rounded-full shadow-lg btn-sm">
    //           <span>Contact Us</span>
    //         </button>
    //       </Link>
    //     </div>
    //   </MobileNav>
    // </Navbar>
    <Navbar className="mx-auto max-w-screen-xl py-2 px-4 lg:px-8 lg:py-4  bg-transparent border-none">
      <div className="container mx-auto flex items-center justify-between text-blue-gray-900">
        <Link to={paths.home}>
          <Typography
            as="a"
            href="#"
            variant="small"
            className="mr-4 cursor-pointer py-1.5 font-normal"
          >
            <img src={Logo} className="w-32" alt="" />
          </Typography>
        </Link>
        <div className="hidden lg:block">{navList}</div>
        <div className="w-32"></div>
        <IconButton
          variant="text"
          className="ml-auto h-6 w-6 text-inherit hover:bg-transparent focus:bg-transparent active:bg-transparent lg:hidden"
          ripple={false}
          onClick={() => setOpenNav(!openNav)}
        >
          {openNav ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              className="h-6 w-6"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          )}
        </IconButton>
      </div>
      <MobileNav open={openNav}>
        <div className="container mx-auto">{navList}</div>
      </MobileNav>
    </Navbar>
  );
}
